import React from 'react';
import '../../styles/PantallaPreviaRegistro.css';

export default function PantallaPreviaRegistro(props) {

    let jugadores = [];
    if(props.jugador1.jugador){
        jugadores.push(props.jugador1);
    }else{
        jugadores.push("");
    }

    if(props.jugador2.jugador){
        jugadores.push(props.jugador2);
    }else{
        jugadores.push("");
    }

    if(props.jugador3.jugador){
        jugadores.push(props.jugador3);
    }else{
        jugadores.push("");
    }

    if(props.jugador4.jugador){
        jugadores.push(props.jugador4);
    }else{
        jugadores.push("");
    }



    return (
        <div className='previa-registro__div--container'>
            <div className='previa-registro__div--datos-de-la-partida'>
                Datos de la partida
            </div>
            <div className='previa-registro__div--container-sesion-elegida-jugadores'>
                <div className='previa-registro__div'>
                    <div>
                        <h4>
                            Sesión elegida
                        </h4>
                    </div>
                    <div>
                        <p>
                            {props.sesionElegida}
                        </p>
                    </div>
                </div>
                <div className='previa-registro__div'>
                    <div>
                        <h4>
                            Numero de jugador/es
                        </h4>
                    </div>
                    <div>
                        <p>
                            {props.jugadoresElegidos}
                        </p>
                    </div>
                </div>
            </div>

            <h3>Jugadores</h3>
            <div className='previa-registro__div--grid-jugadores'>

                <div className='previa-registro__div--container-datos-img'>
                    <div>
                        <div>
                            {jugadores[0].jugador}
                        </div>
                        <div>
                            {jugadores[0].email}
                        </div>
                    </div>
                    <div className='previa-registro__div--container-imagen'>
                        {props.arrayJugador1}
                    </div>
                </div>

                <div className='previa-registro__div--container-datos-img'>
                    <div>
                        <div>
                            {jugadores[1].jugador}
                        </div>
                        <div>
                            {jugadores[1].email}
                        </div>
                    </div>
                    <div className='previa-registro__div--container-imagen'>
                        {props.arrayJugador2}
                    </div>
                </div>

                <div className='previa-registro__div--container-datos-img'>
                    <div>
                        <div>
                            {jugadores[2].jugador}
                        </div>
                        <div>
                            {jugadores[2].email}
                        </div>
                    </div>
                    <div className='previa-registro__div--container-imagen'>
                        {props.arrayJugador3}
                    </div>
                </div>

                <div className='previa-registro__div--container-datos-img'>
                    <div>
                        <div>
                            {jugadores[3].jugador}
                        </div>
                        <div>
                            {jugadores[3].email}
                        </div>
                    </div>
                    <div className='previa-registro__div--container-imagen'>
                        {props.arrayJugador4}
                    </div>
                </div>
            </div>
        </div>
    )
}
